var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jobIndex" },
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                data: _vm.tableData,
                option: _vm.tableOption,
                page: _vm.page,
                "table-loading": _vm.tableLoading,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "row-save": _vm.save,
                "row-update": _vm.update,
                "refresh-change": _vm.refreshChange,
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
                "search-change": _vm.handleFilter,
                "search-reset": _vm.handleSearchReset,
              },
              scopedSlots: _vm._u([
                {
                  key: "jobStatus",
                  fn: function (scope) {
                    return [
                      scope.row.jobStatus === "1"
                        ? _c(
                            "div",
                            [
                              _c("el-tag", { attrs: { type: "info" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getDicNameJobStatus(scope.row.jobStatus)
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : scope.row.jobStatus === "2"
                        ? _c(
                            "div",
                            [
                              _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getDicNameJobStatus(scope.row.jobStatus)
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : scope.row.jobStatus === "3"
                        ? _c(
                            "div",
                            [
                              _c("el-tag", { attrs: { type: "danger" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getDicNameJobStatus(scope.row.jobStatus)
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "jobExecuteStatus",
                  fn: function (scope) {
                    return [
                      scope.row.jobExecuteStatus === "0"
                        ? _c(
                            "div",
                            [
                              _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getDicNameJobExecuteStatus(
                                      scope.row.jobExecuteStatus
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("el-tag", { attrs: { type: "danger" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getDicNameJobExecuteStatus(
                                      scope.row.jobExecuteStatus
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                    ]
                  },
                },
                {
                  key: "cronExpressionForm",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "cron" },
                        [
                          _c(
                            "el-popover",
                            {
                              model: {
                                value: _vm.cronPopover,
                                callback: function ($$v) {
                                  _vm.cronPopover = $$v
                                },
                                expression: "cronPopover",
                              },
                            },
                            [
                              _c("cron", {
                                attrs: { i18n: "cn" },
                                on: {
                                  change: _vm.changeCron,
                                  close: function ($event) {
                                    _vm.cronPopover = false
                                  },
                                },
                              }),
                              _c("el-input", {
                                attrs: {
                                  slot: "reference",
                                  placeholder: "请输入定时策略",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.cronPopover = true
                                  },
                                },
                                slot: "reference",
                                model: {
                                  value: _vm.form.cronExpression,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "cronExpression", $$v)
                                  },
                                  expression: "form.cronExpression",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "menu",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-info", type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.handleJobLog(scope.row)
                            },
                          },
                        },
                        [_vm._v("日志")]
                      ),
                      _vm.permissions.job_sys_job_start_job
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-caret-right",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleStartJob(scope.row)
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t启动\n\t\t\t\t")]
                          )
                        : _vm._e(),
                      _vm.permissions.job_sys_job_shutdown_job
                        ? _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-error", type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleShutDownJob(scope.row)
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t暂停\n\t\t\t\t")]
                          )
                        : _vm._e(),
                      _vm.permissions.job_sys_job_edit
                        ? _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-edit", type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleUpdate(
                                    scope.row,
                                    scope.index
                                  )
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t修改\n\t\t\t\t")]
                          )
                        : _vm._e(),
                      _vm.permissions.job_sys_job_run_job
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-s-promotion",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleRunJob(scope.row)
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t执行\n\t\t\t\t")]
                          )
                        : _vm._e(),
                      _vm.permissions.job_sys_job_del
                        ? _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-delete", type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(
                                    scope.row,
                                    scope.index
                                  )
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t删除\n\t\t\t\t")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _vm.permissions.job_sys_job_add
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新建任务")]
                      )
                    : _vm._e(),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "暂停全部运行状态的定时任务",
                        placement: "top",
                      },
                    },
                    [
                      _vm.permissions.job_sys_job_shutdown_job
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "warning" },
                              on: { click: _vm.shutdownJobs },
                            },
                            [_vm._v("\n\t\t\t\t\t\t暂停全部任务\n\t\t\t\t\t")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "启动全部暂停状态的定时任务",
                        placement: "top",
                      },
                    },
                    [
                      _vm.permissions.job_sys_job_start_job
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "success" },
                              on: { click: _vm.startJobs },
                            },
                            [_vm._v("\n\t\t\t\t\t\t启动全部任务\n\t\t\t\t\t")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-tooltip",
                    { attrs: { content: "谨慎使用", placement: "top" } },
                    [
                      _vm.permissions.job_sys_job_refresh_job
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.refreshJobs },
                            },
                            [_vm._v("\n\t\t\t\t\t\t重置全部任务\n\t\t\t\t\t")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm.dialogFormVisible ? _c("jobLog", { ref: "logRef" }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }